/** Types used when generating an account number. */
export enum NumberingTaskType {
  Interactive1 = 1,
  Interactive2 = 2,
  Automation1 = 3,
  Automation2 = 4,
  Web1 = 5,
  Web2 = 6,
  Custom1 = 7,
  Custom2 = 8,
}

/** Fields for generating an account number.  */
export interface AccountNumberFields {
  numberingTaskType: NumberingTaskType;
  requiredInput: { [key: string]: string | null };
}

export interface AccountNumber {
  id: string;
  editMask: string;
  validationMask: string;
  helpText: string;
}
